import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-log-dialog" }
const _hoisted_2 = {
  key: 0,
  style: {"margin-bottom":"12px","color":"#666"}
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createBlock(_component_oio_modal, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "操作日志",
    width: "760px",
    "z-index": 2000,
    footer: null,
    "cancel-callback": _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.billingBill)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(" 开票单："),
              _createElementVNode("strong", null, _toDisplayString(_ctx.billingBill.code), 1),
              (_ctx.billingBill.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / " + _toDisplayString(_ctx.billingBill.name), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          "data-source": _ctx.logs,
          loading: _ctx.loading,
          pagination: false,
          size: "small",
          bordered: "",
          "row-key": "id",
          scroll: { y: 420 }
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'operationType')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.operationTypeText(record.operationType)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "cancel-callback"]))
}